export const introduction = {
  coverPage: 'Cover page',
  citation: 'Citation',
  tableOfContents: 'Table of contents',
  references: 'References',
  introductionIso14044Standards: 'Introduction (ISO 14044 Standards)',
  criticalReviewConsiderations: 'Critical review considerations',
};
export const executiveSummary = {
  projectSummary: 'Project summary',
  spiderChartSummary: 'Spider chart summary',
  resultSummaryTable: 'Results summary table',
  comparisonToBenchmark: 'Comparison to benchmark',
  annualizedResult: 'Annualized results',
};

export const goalAndScope = {
  goalAndScope: 'Goal and scope',
  functionalUnit: 'Functional unit',
  systemBoundary: 'System boundary',
  includedProcesses: 'Included processes',
  excludedProcesses: 'Excluded processes',
  multiFunctionality: 'Multi-functionality',
  impactCategories: 'Impact assessment categories',
  dataQualityFramework: 'Data quality framework',
};

export const impactAssessmentResult = {
  resultsCharacterization: 'Results characterization',
  resultSummaryNormalized: 'Results summary normalized',
  annualizedResult: 'Annualized results',
  resultAnnulizedEquivalence: 'Results annualized with equivalence values',
};

export const inventory = {
  inventoryAnalysis: 'Inventory analysis',
  foregroundDataEnter: 'Foreground data entered',
  otherAssumptions: 'Other assumptions',
  backGroundData: 'Background data sources',
};

export const interpretation = {
  interpretation: 'Interpretation',
  contributionalAnalysis: 'Contribution analysis',
  contributionalAnalysisByStage: 'Contribution analysis by life cycle stage',
  contributionalAnalysisByComponent: 'Contribution analysis by component',
  contributionalAnalysisByPackaging: 'Contribution analysis by packaging level',
  contributionalAnalysisByTransport: 'Contribution analysis by transport',
  contributionalAnalysisByProductLoss: 'Contribution analysis by product loss',
  sensitivityAssessment: 'Sensitivity assessment',
  dataQualityAssessment: 'Data quality assessment',
  interpretationSummary: 'Interpretation summary',
};

export const conclusion = {
  limitationOfStudy: 'Limitations of the study',
  recommendations: 'Recommendations and conclusions',
};
